import { useEffect } from 'react';

const SEO = ({ title, description }) => {
  useEffect(() => {
    // Update document title
    document.title = title;
    
    // Update meta description
    let metaDescription = document.querySelector('meta[name="description"]');
    if (!metaDescription) {
      metaDescription = document.createElement('meta');
      metaDescription.setAttribute('name', 'description');
      document.head.appendChild(metaDescription);
    }
    metaDescription.setAttribute('content', description);

    return () => {
      // Clean up can be done here if needed
    };
  }, [title, description]);

  return null;
};

export default SEO;